import React from "react";

const TableData = ({ businessRecords }) => {
  return (
    <div className="container mt-4">
      <div className="row">
        {businessRecords?.map((record) => (
          <div className="col-xl-6 mb-3">
            <div className="card">
              <div className="card-header border-0 pb-0">
                <h2 className="card-title">{record?.year}</h2>
              </div>
              <div className="card-body pb-0 pt-2">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item d-flex px-0 justify-content-between">
                    <strong>Net Worth</strong>
                    <span className="mb-0">{record?.netWorth}</span>
                  </li>
                  <li className="list-group-item d-flex px-0 justify-content-between">
                    <strong>Pre Tax Profit</strong>
                    <span className="mb-0">{record?.preTaxProfit}</span>
                  </li>
                  <li className="list-group-item d-flex px-0 justify-content-between">
                    <strong>Turn Over</strong>
                    <span className="mb-0">{record?.turnover}</span>
                  </li>
                </ul>
              </div>
              <div className="card-footer pt-0 pb-0 text-center">
                <div className="container m-0">
                  <div className="row p-2">
                    <div className="col-xl-6 border-end">
                      <h3 className="text-primary">{record?.employees}</h3>
                      <span>Employees</span>
                    </div>
                    <div className="col-xl-6">
                      <h3 className="text-primary">{record?.creditScore}</h3>
                      <span>Credit Score</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableData;
